var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBlackLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "16px",
    viewBox: "0 0 9 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrowBlackLocation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.29825459,7.70107684 C8.3133838,7.94756491 8.23175545,8.19883617 8.05336956,8.39370959 L2.24279644,14.7413318 C1.9490383,15.0622409 1.45075205,15.0842511 1.12984295,14.790493 C1.1127404,14.7748374 1.09633739,14.7584344 1.08068182,14.7413318 C0.751802808,14.3820558 0.751802808,13.8310834 1.08068182,13.4718074 L6.36317193,7.70107684 L1.08068182,1.93034631 C0.751802808,1.57107026 0.751802808,1.0200979 1.08068182,0.660821859 C1.37443997,0.339912767 1.87272621,0.317902577 2.19363531,0.611660723 C2.21073786,0.62731629 2.22714087,0.643719307 2.24279644,0.660821859 L8.05336956,7.00844409 C8.23175545,7.20331752 8.3133838,7.45458878 8.29825459,7.70107684 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Members-Swipe-Skeleton",
    transform: "translate(-407.000000, -524.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(411.700000, 531.940000) scale(-1, 1) translate(-411.700000, -531.940000) translate(407.200000, 524.440000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "arrowBlackLocation",
    fill: "#333333",
    fillRule: "nonzero",
    transform: "translate(4.567026, 7.701077) scale(-1, 1) translate(-4.567026, -7.701077) ",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlackLocation);
export default __webpack_public_path__ + "static/media/arrowBlackLocation.4eb75882262df0f83d9775af748fed62.svg";
export { ForwardRef as ReactComponent };